import React from 'react';
import HealthCheck from '../app/healthcheck';
import runtimeEnv from '@mars/heroku-js-runtime-env';

const App = (): React.ReactElement => {
  const {
    /* eslint-disable @typescript-eslint/naming-convention */
    REACT_APP_HEALTHCHECK_FEATURE_FLAG_DOWNLOAD_CERTIFICATE,
    REACT_APP_HEALTHCHECK_FEATURE_FLAG_GOOGLE_ANALYTICS,
    /* eslint-enable @typescript-eslint/naming-convention */
  } = runtimeEnv();

  return (
    <HealthCheck
      downloadCertificate={
        REACT_APP_HEALTHCHECK_FEATURE_FLAG_DOWNLOAD_CERTIFICATE === 'true'
      }
      googleAnalyticsFunctionality={
        REACT_APP_HEALTHCHECK_FEATURE_FLAG_GOOGLE_ANALYTICS === 'true'
      }
    />
  );
};

export default App;
